export const Rules = {
    min8character: (rule: any, value: any, callback: (error?: string) => void) => {
        if (value && value.length > 7) {
            return Promise.resolve()
        }
        return Promise.reject("La clave debe tener almenos 7 caracteres")
    }
}